import { render } from "./CostList.vue?vue&type=template&id=e588ed5c&scoped=true"
import script from "./CostList.vue?vue&type=script&lang=js"
export * from "./CostList.vue?vue&type=script&lang=js"

import "./CostList.vue?vue&type=style&index=0&id=e588ed5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e588ed5c"]])

export default __exports__